import { useGreeterVenueApi } from "@greeter/matter";
import { TicketOverviewPage } from "./TicketOverviewPage";

export function TicketOverviewPageApiHandler() {
  const { api } = useGreeterVenueApi();
  return <TicketOverviewPage api={api} />;
}
